module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab137-f8a36523104e3321f224b579898505c4.jpg";